/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2025-02-26",
    versionChannel: "nightly",
    buildDate: "2025-02-26T00:06:16.416Z",
    commitHash: "019db9c77b9e9be5fa182964f3e4f5cc6be9e195",
};
